import React, { Suspense } from "react";
import { Image } from "mui-image";
import { Button, CircularProgress } from "@mui/material";
import PAYMENT from "../../assets/images/payment-automation.svg";
import ADS from "../../assets/images/ads.svg";
import HEXA from "../../assets/images/home-verified-bg.webp";
import { ReactComponent as ARROW } from "../../assets/images/arrow-right.svg";
const LottieAnimation = React.lazy(() =>
  import("../../components/LottieAnimation")
);

const typesArr = [
  {
    icon: PAYMENT,
    title: "Payment automation",
    text: "Send salaries and payouts\nto vendors in one click.",
  },
  {
    icon: ADS,
    title: "Ads and management",
    text: "Run ads to maximise revenue and\nawareness of your brand.",
  },
];

const contentArr = [
  {
    gif: "/lotties/centre-two.json",
    title: "List and sell services",
    text: "Sell memberships and services directly to customers without any commission cuts.",
  },
  {
    gif: "/lotties/centre-three.json",
    title: "Showcase your amenities",
    text: "Provide details about your fitness centre and studio.",
  },
  {
    gif: "/lotties/centre-four.json",
    title: "Link trainers",
    text: "Link your team’s dopamine account with your centre.",
  },
  {
    gif: "/lotties/centre-five.json",
    title: "Manage members and their profiles",
    text: "Provide additional services to your members with online training, beginner programs and progress tracking.",
  },
  {
    gif: "/lotties/Brands_Affiliations.json",
    title: "Brand affiliations & increased earnings",
    text: "Create affiliate programs for experts to join the program & increase sales. Join affiliate programs with brands for events and products.",
  },
  {
    gif: "/lotties/centre-seven.json",
    title: "Interconnected Ecosystem access",
    text: "Be a part of an Interconnected business community and grow exponentially.",
  },
];

const ismobile = window.innerWidth <= 768;

function NewlineText(props) {
  const text = props.text;
  const newText = text.split("\n").map((str) => <p>{str}</p>);

  return newText;
}

const OtherContent = ({ setRequestDrawer = () => {} }) => {
  return (
    <>
      {contentArr.map((c, i) => (
        <div key={c.title}>
          {i === 5 && (
            <div className="home-types expert-types">
              {typesArr.map((type, i) => (
                <div
                  key={type.title}
                  style={{ border: i === 2 && "none" }}
                  className="home-type"
                >
                  <div className="home-type-content expert-type-content">
                    {/* <div className="home-type-icon"> */}
                    <Image
                      height="100%"
                      width="84px"
                      fit="contain"
                      src={type.icon}
                      duration={800}
                      alt=""
                      showLoading={true}
                      className="icon-image"
                    />
                    {/* </div> */}
                    <span>{type.title}</span>
                    <NewlineText text={type.text} />
                  </div>
                </div>
              ))}
            </div>
          )}
          <div
            style={{
              flexDirection: ismobile
                ? "column-reverse"
                : (i + 1) % 2
                ? "row"
                : "row-reverse",
              backgroundColor: ismobile
                ? (i + 1) % 2
                  ? "#FDF4E5"
                  : "#FFE9E0"
                : "",
            }}
            className="home-content expert-content"
          >
            <div
              style={{
                backgroundColor: !ismobile
                  ? (i + 1) % 2
                    ? "#FDF4E5"
                    : "#FFE9E0"
                  : "",
              }}
              className="home-content-gif-container"
            >
              <Suspense
                fallback={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "3rem",
                    }}
                  >
                    <CircularProgress size="3rem" />
                  </div>
                }
              >
                <div className="home-content-gif">
                  {c.gif && (
                    <LottieAnimation path={JSON.parse(JSON.stringify(c.gif))} />
                  )}
                  {c.img && (
                    <Image
                      height="100%"
                      width="100%"
                      fit="contain"
                      src={c.img}
                      duration={800}
                      alt=""
                      showLoading={true}
                      style={ismobile ? { padding: "0 20px 20px 20px" } : null}
                    />
                  )}
                </div>
              </Suspense>
            </div>
            <div className="home-content-text">
              <div>
                <span>{c.title}</span>
                <p>{c.text}</p>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div style={{ borderTop: "1px solid #dfdfdf" }} className="home-content">
        <div className="home-content-text">
          <div>
            <span>
              Create <br />
              Savings accounts
            </span>
            <p className="coming-soon-text">Coming Soon</p>
          </div>
        </div>
        <div className="home-content-gif-container">
          <div
            style={{ width: ismobile ? "80%" : "28vw", margin: "3rem auto" }}
            className="home-content-gif"
          >
            <Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "3rem",
                  }}
                >
                  <CircularProgress size="3rem" />
                </div>
              }
            >
              {/* <ImageLoader  /> */}
              <LottieAnimation path="/lotties/expert-seven.json" />
            </Suspense>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#DFDFDF" }} className="home-content">
        <div className="home-content-text">
          <div>
            <span>
              One click <br />
              approved loans
            </span>
            <p className="coming-soon-text">Coming Soon</p>
          </div>
        </div>
        <div className="home-content-gif-container">
          <div
            style={{ width: ismobile ? "80%" : "28vw", margin: "3rem auto" }}
            className="home-content-gif"
          >
            <Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "3rem",
                  }}
                >
                  <CircularProgress size="3rem" />
                </div>
              }
            >
              {/* <ImageLoader  /> */}
              <LottieAnimation path="/lotties/expert-eight.json" />
            </Suspense>
          </div>
        </div>
      </div>

      <div className="home-request-access-container">
        <div className="home-request-access">
          <div className="home-request-img1">
            <img
              src={HEXA}
              alt=""
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
            />
          </div>
          <div className="home-request-img2">
            <img
              src={HEXA}
              alt=""
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
            />
          </div>
          <div className="home-request-title">
            Verified Account for your Fitness Business.
          </div>
          <Button
            onClick={() => setRequestDrawer(true)}
            id="home-main-button"
            variant="contained"
            size="large"
            color="secondary"
          >
            Request access
            <ARROW className="home-main-btn-icon" />
          </Button>
        </div>
      </div>
    </>
  );
};

export default React.memo(OtherContent);
